var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import dayjs from 'dayjs';
import { NotificationTypeEnum } from '@/stores/notification/defs';
import { fetchSuggestedKeywordsApi } from '@/includes/api/keywords/suggestions';
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
import { CampaignStatus } from '@local/typedefs/dist/protos/campaign/Campaign';
const ONE_DAY = 24 * 60 * 60 * 1000;
export const checkCampaignStartDateAndNotify = ({ notify, startDate, campaignStatus, }) => {
    if (!startDate || campaignStatus !== CampaignStatus.CAMPAIGN_STATUS_LIVE)
        return;
    const today = new Date();
    const diff = today.getTime() - new Date(startDate).getTime();
    if (diff < ONE_DAY) {
        notify({
            message: `Your campaign data would start populating here within 24 hrs of your start date.`,
            type: NotificationTypeEnum.SUCCESS,
        });
    }
};
export const checkCampaignBudgetAndWarn = ({ notify, spent, budget, campaignStatus, }) => {
    if (campaignStatus !== CampaignStatus.CAMPAIGN_STATUS_LIVE)
        return;
    const isCloseToExhaustion = spent >= budget * 0.8 && spent < budget;
    if (isCloseToExhaustion) {
        notify({
            message: `More than 80% of your campaign budget is about to be exhausted. To keep your campaign running, add more budget by editing campaign budget.`,
            type: NotificationTypeEnum.ERROR,
        });
    }
};
export const checkKeywordBidAndWarn = (_a) => __awaiter(void 0, [_a], void 0, function* ({ notify, keywords, candidateIds, placementIds, adUnitType, accountId, campaignStatus, }) {
    try {
        if (!keywords ||
            !keywords.length ||
            campaignStatus !== CampaignStatus.CAMPAIGN_STATUS_LIVE)
            return;
        const keywordsText = keywords.map((i) => i.keywordText);
        const suggestedKeywords = yield fetchSuggestedKeywordsApi({
            candidateIds,
            placementIds,
            adUnitType,
            accountId,
            keywords: keywordsText,
        });
        const filteredKeywords = keywords.filter((keyword) => {
            const suggestedKeyword = suggestedKeywords.find((suggestedKeyword) => suggestedKeyword.keywordText === keyword.keywordText);
            if (!suggestedKeyword ||
                keyword.matchType ===
                    KeywordMatchType.KEYWORD_MATCH_TYPE_INVALID)
                return false;
            return (keyword.bid < suggestedKeyword[keyword.matchType].bid.minimumBid);
        });
        if (filteredKeywords.length > 0) {
            const filteredKeywordsText = filteredKeywords
                .map((i) => i.keywordText)
                .join(', ');
            notify({
                message: `Some of your keywords are below the minimum bid. To keep your campaign running, increase the bid of these keywords - ${filteredKeywordsText}.`,
                type: NotificationTypeEnum.ERROR,
            });
        }
    }
    catch (err) {
        if (__DEV__) {
            console.error(err);
        }
    }
});
export const checkCampaignEndDateAndWarn = ({ notify, endDate, campaignStatus, }) => {
    if (!endDate || campaignStatus !== CampaignStatus.CAMPAIGN_STATUS_LIVE)
        return;
    const today = new Date();
    const diff = new Date(endDate).getTime() - today.getTime();
    if (diff > ONE_DAY * 5) {
        return;
    }
    notify({
        message: `Your campaign ends on ${dayjs(endDate).format('MMM DD, YYYY')}. To keep your campaign running, extend your campaign range by editing campaign dates.`,
        type: NotificationTypeEnum.ERROR,
        duration: -1,
    });
};
const createColumn = (title, sortable, key, width) => ({ title, sortable, key, width });
export const PRODUCT_TABLE_COLUMNS = [
    createColumn('Products', false, 'product', '25%'),
    createColumn('Spend', true, 'spend', '15%'),
    createColumn('Impressions', true, 'impression', '15%'),
    createColumn('Card Additions', true, 'addToCart', '15%'),
    createColumn('GMV', true, 'gmv', '15%'),
    createColumn('ROI', true, 'roi', '15%'),
];
